import { l10n } from '@ott/l10n';
import rules from '@ott/utility-form-validate-rules';

import { LoaderWithErrorPayload } from '../redux/auth/types';

import * as yup from 'yup';

declare module 'yup' {
  interface StringSchema {
    phone(): StringSchema;
  }
}

yup.addMethod(yup.string, 'phone', function () {
  return this.test('phone', l10n('wrong.phone'), function (value) {
    const { path, createError } = this;

    if (!rules.isRequired(value)) {
      return createError({ path, message: l10n('required.phone') });
    }

    if (!rules.isPhone(value)) {
      return createError({ path, message: l10n('wrong.phone') });
    }

    return true;
  });
});

export const getSignInPhoneSchema = (pinStatus: LoaderWithErrorPayload) =>
  yup.object().shape({
    phone: yup.string().phone(),
    pin: yup.string().when('phone', {
      is: () => pinStatus.success,
      then: yup.string().required(l10n('auth.emailRequired')),
    }),
  });

export const signInScheme = yup.object({
  email: yup.string().required(l10n('required.email')).email(l10n('wrong.email')),
  password: yup.string().required(l10n('required.password')),
});

export const forgotPasswordScheme = yup.object({
  passwordRecoveryEmail: yup
    .string()
    .required(l10n('required.emailLong'))
    .email(l10n('wrong.email')),
});
